module.exports = function (id) {
    return {
        event: 'dynamicContentCard',
        ecommerce: {
            dynamicContent: { id },
        },
    };
};



// WEBPACK FOOTER //
// ./src/shop/trolley/gtmmapper/dynamic-content-analytics-mapper.js